<template>
  <div class="goETC">
    <section class="page-content">
      <p>1、打开微信，在搜索框输入ETC助手进行搜索</p>
      <p>2、点击ETC助手则可进入ETC助手小程序</p>
      <img src="../../assets/pakd/goETC.png" alt="">
    </section>
    <section class="page-bottom"></section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

export default {
  name: 'goETC',
  mixins: [FunMixin],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.goETC {
  background-color: #f5f5f5;
  .page-content {
    padding: 30px 40px 50px;
    font-size: 0;
    p{
      font-size: 30px;
      line-height: 42px;
    }
    img{
      margin: 30px auto 0;
      width: 670px;
      height: 1235px;
    }
  }
  .page-bottom {
  }
}
</style>
